import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';

import {
  addConversation,
  navToConversation
} from '@/models/conversations/actions';
import { getOrder, addOrder, showAssignDialog } from '@/models/orders/actions';
import cn from 'classnames';
import dayjs from 'dayjs';
import { Badge, Icon, Dropdown, Menu, Avatar, Tooltip, Tag, Button, Popover, Popconfirm, message } from 'antd';
import * as utils from '@/utils';
import * as userSelector from '@/models/user/selectors'
import StatusBadge from '@/components/StatusBadge';
import TagFlag from '@/components/TagFlag';
import styles from './style.module.less';
import regions, { simplifyName } from '@/utils/regions';
import * as taskHallServices from '@/models/taskHall/services';
import { orderStatus } from '@/models/orders/defines/constants';
import TenantStatusBadge from '../TenantStatusBadge';



const isTenantMode = process.env.APP_MODE === 'tenant';


const twoHourAgo = Date.now() - 1000 * 60 * 60 * 2;
function simplifyLogoName(name) {
  var shortName = name;
  var provinces = regions.provinces;
  for (var idx in provinces) {
    var pro = provinces[idx]
    if (shortName.indexOf(pro.name) != -1) {
      shortName = name.replace(pro.name, '')
    }
    var proShort = simplifyName(pro.name)
    if (shortName.indexOf(proShort) != -1) {
      shortName = shortName.replace(proShort, '')
    }
  }
  return shortName.substr(0, Math.min(4, shortName.length))
}
export function TaskItem({
  convId, item = {}, type, taskHallSelectOrderId,
  showConvFold, change, tastHallType, resetTaskHall,
  onProcessedSuccess, onProcessedSuccessqqqq
}) {
  const dispatch = useDispatch();

  const order = item.order;

  // const isActive = useSelector(isActiveSelector(convId));
  const isActive = order._id == taskHallSelectOrderId;
  const prevActiveState = usePrevious(isActive);
  const clickHandler = (orderId, convId) => {
    if (!isActive) {
      dispatch(navToConversation('', ''));
      typeof change === 'function' && change(orderId, convId)
    }
  }
  const latest_ts = dayjs(item.latest_ts);
  const latestTs = latest_ts.isSame(dayjs(), 'day')
    ? latest_ts.format('HH:mm')
    : latest_ts.fromNow();
  // const latestTs = latest_ts.format('HH:mm:ss')

  const user = useSelector(userSelector.getCurrentUser)

  //处理按钮
  const processOrder = (orderId, convId, tid) => {
    taskHallServices.setDeal({
      orderId: orderId,
      convId: convId,
      tid: tid
    }).then(async result => {
      localStorage.setItem("need_expand_chat_orderId", orderId)
      localStorage.setItem("need_expand_chat_convId", convId)

      const { order, ...conv } = item
      await dispatch(addOrder(order));
      await dispatch(addConversation(conv));
      resetTaskHall()
      dispatch(getOrder(orderId));
      typeof onProcessedSuccess == 'function' && onProcessedSuccess()
      if (result.message_type == 2) {
        clickHandler(orderId, convId)
        typeof onProcessedSuccessqqqq == 'function' && onProcessedSuccessqqqq(orderId, convId)
      }
      message.success('操作成功')
    }).catch((err) => {
      message.error(err.message || '操作失败，请刷新重试');
    })
      .finally(() => {
      });
  }

  //忽略按钮
  const ignoreOrders = (orderId) => {
    taskHallServices.setIgnore({
      source: tastHallType == 1 ? 4 : (tastHallType == 6?6:1),
      orderId: orderId,
    }).then(result => {
      message.success('操作成功')
      resetTaskHall()
    }).catch((err) => {
      message.error(err.message || '操作失败，请刷新重试');
    })
      .finally(() => {
      });
  }
  useUpdateEffect(() => {
    // 异步更新 当前order的信息
    if (isActive && prevActiveState !== isActive) {
      dispatch(getOrder(order._id));
    }
  });

  useMount(() => {
    if (isActive) {
      dispatch(getOrder(order._id));
    }
  });

  // const timeout =
  //   order.worker &&
  //   !order.service_time &&
  //   order.worker_assigned_at &&
  //   new Date(order.worker_assigned_at).getTime() < twoHourAgo;

  // TODO: currentId有变化的时候需要将滚动条移植相应位置
  const status = utils.getStatus(order);

  const BottomRightMenu = () => {
    return (
      <div className={styles.bottomRightMenu} onClick={e => e.stopPropagation()}>
        <>
          {(
            (
              process.env.APP_MODE !== 'tenant' &&
              order?.tip?.[0]?.is_deal == 0 &&
              // order?.tip?.[0]?.message_type == 1 &&
              order?.order_tip_op == 1
              && order?.tip?.[0]?.type != 50 && order?.tip?.[0]?.type != 31
            )
            ||
            (
              order?.tip?.[0]?.type == 3 &&
              order?.tip?.[0]?.role == '师傅'
            )
          )
            &&
            (
              <Button type="primary" size="small"
                style={{ marginRight: '10px' }}
                onClick={() => { processOrder(order._id, item._id, order.tip[0]._id) }}
              >处理</Button>
            )

          }
          {(
            (process.env.APP_MODE !== 'tenant' && order?.tip?.[0]?.is_deal == 0 && order?.tip?.[0]?.message_type == 2) ||
            (process.env.APP_MODE !== 'manager' && order?.tip?.[0]?.message_type == 2)
          )
            &&
            (
              <Button type="primary" size="small"
                style={{ marginRight: '10px' }}
                onClick={() => { processOrder(order._id, item._id, order.tip[0]._id) }}
              >回复</Button>
            )}
          {
            (
              (
                type != 'prevScreen' && showConvFold == false &&
                (
                  order?.tip?.[0]?.is_deal == 1 ||
                  order?.order_tip_op == 2 ||
                  (order?.order_tip_op == 0 && order?.tip?.[0]?.is_deal == 0) ||
                  (order?.order_tip_op == 1 && order?.tip?.[0]?.is_deal == 0)
                )
              ) || (
                type != 'prevScreen' && order?.ticket_type == 2
              )
            )
            &&
            (
              <Button type="primary" size="small"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  typeof onProcessedSuccess == 'function' && onProcessedSuccess()
                  ignoreOrders(order._id)
                }}
              >忽略</Button>
            )
          }
        </>

        {(
          Array.isArray(order.tip) && order.tip.length > 0 &&
          user.get("_id") == item?.activeDeal?._id &&
          order.tip[0]?.message_type > 0 &&
          item?.activeDeal?.avatar
        ) &&
          (<Popover placement="topRight" content={
            (
              <div>
                <span>{order.tip[0].role}</span>
                <span style={{ color: '#FF731B', margin: '0 5px' }}>{order.tip[0]?.user?.name}</span>
                <span>{utils.tipType[order.tip[0].type]}</span>
              </div>
            )}>
            <img src={item?.activeDeal?.avatar} style={{ width: '24px', height: '24px', borderRadius: '50%' }} />
            {/* <img src="/images/reply-status.png" style={{ width: '24px', height: '24px' }} /> */}
            {/* <img src="/images/reply-status-active.gif" style={{ width: '24px', height: '24px' }} /> */}
          </Popover>)}

        {(
          Array.isArray(order.tip) && order.tip.length > 0 &&
          user.get("_id") != item?.activeDeal?._id &&
          order.tip[0]?.is_deal == 1
        ) &&
          (<Popover placement="topRight" content={
            (
              <div>
                <span>客服</span>
                <span style={{ color: '#FF731B', margin: '0 5px' }}>{item?.activeDeal?.name}</span>
                <span>正在处理</span>
              </div>
            )}>
            <Avatar size="small" src={item?.activeDeal?.avatar} icon="user" />
            {/* <img src="/images/reply-status.png" style={{ width: '24px', height: '24px' }} /> */}
            {/* <img src="/images/reply-status-active.gif" style={{ width: '24px', height: '24px' }} /> */}
          </Popover>)}
      </div>
    )
  }

  return (
    <div className={cn(styles.item,
      order?.order_tip_op == 1 && styles.operate,
      order?.order_tip_op == 2 && styles.notice,
      isActive && styles.active)}
      onClick={() => { clickHandler(order._id, item._id) }}
    >
      {order?.order_tip_op == 2 ? (<div className={cn(styles.itemstatus, styles.blue)}
      >
        提醒消息
      </div>)
        : <>
          {(order?.tip?.[0]?.type == 30 && order.is_urgent && tastHallType == 1) && (<div className={styles.itemstatus}>
            预约超时
          </div>)}
          {(order?.tip?.[0]?.type == 32 && tastHallType == 1) && (<div className={styles.itemstatus}>
            上门超时
          </div>)}
          {(order?.tip?.[0]?.type == 31 && tastHallType == 1) && (<div className={styles.itemstatus}>
            回复超时
          </div>)}
        </>
      }
      <div className={styles.workorder}>
        <div className={styles.tags}>
          <StatusBadge style={{ background: '#4D4D4D' }}>
            {latestTs}
          </StatusBadge>
          {order?.tip?.[0]?.type == 99 && <StatusBadge style={{ background: '#FF3232' }}>
            新工单
          </StatusBadge>}
          {Object.keys(status).length > 0 && <StatusBadge style={status.style}>
            {status.text}{(order.is_guaqi && [
              orderStatus.PROCESSING_WAIT_APPOINTMENT,
              orderStatus.PROCESSING_WAIT_SERVICE,
              orderStatus.WORKER_LOCATION_CHECKED,
            ].includes(item?.order?.status_code)) ? ' | 挂起' : ''}
          </StatusBadge>}

          {order?.payer_type == 2 && <StatusBadge style={{
            color: 'red',
            fontSize: '16px',
            fontWeight: 'bold',
            background: 'transparent'
          }}>
            保外
          </StatusBadge>}

          {!order?.is_retail && <TenantStatusBadge order={order} />}
          <TagFlag itemId={item?._id} flag={item.tag_flag} change={() => {
            resetTaskHall()
            dispatch(getOrder(order._id))
          }} />

          {(order?.tenant?.quotationStart > 0 && order?.tenant?.quotationEnd > 0) && <div style={{ float: 'right' }}>
            合作价：{order?.tenant?.quotationStart} - {order?.tenant?.quotationEnd}
          </div>}
        </div>
        {order?.is_retail ?
          <div className={styles.workorderinfo} >

            <div className={styles.infoitem}>
              <div className={styles.desclist}>
                <div className={styles.descitem}>
                  服务内容：{order?.order_name || ''}
                </div>
              </div>
            </div>
            <div className={styles.infoitem}>
              <div className={styles.desclist}>
                <div className={styles.descitem}>
                  订单编号：{order.order_no}
                </div>
              </div>
            </div>
          </div>
          :
          <div className={styles.workorderinfo} >
            <div className={styles.infoitem}>
              {
                process.env.APP_MODE === 'manager'
                &&
                (
                  order.tenant
                    ?
                    (
                      <div className={styles.logo}>
                        {/* <span className={styles.tit}>企业</span> */}
                        <Tooltip title={order.tenant?.short_name}>
                          {order.tenant?.logo ? (
                            <Avatar
                              size={42}
                              src={order.tenant.logo}
                            />) :
                            (
                              <Avatar shape="square" size={42}
                                style={{ backgroundColor: '#87d068' }}>{simplifyLogoName(order?.tenant?.short_name)}</Avatar>)
                          }
                        </Tooltip>
                      </div>
                    )
                    :
                    (
                      <div className={styles.logo}>
                        {/* xxx 先生 */}
                        {/* <Avatar size="small" src={order.tenant?.logo} /> */}
                        {/* <span className={styles.tit}>下单人</span> */}
                      </div>
                    )
                )
              }
              <div className={styles.desclist}>
                <div className={styles.descitem}>
                  {order?.tenant?.short_name}
                  {(order?.tenant?.short_name && order?.tenant?.contact_name) ? '/' : ''}
                  {order?.tenant?.contact_name}
                </div>
                <div className={styles.descitem}>
                  {order?.tenant?.owner?.remark || ''}
                  {(order?.tenant?.owner?.remark && order?.tenant?.contact_tel) ? '/' : ''}
                  {order?.tenant?.contact_tel}
                </div>

              </div>
            </div>
            <div className={styles.infoitem}>
              <div className={styles.desclist}>
                <div className={styles.descitem}>
                  {/* <Badge count={item.unread_count} offset={[7, 0]}  > */}
                  {order.order_no}
                  {/* </Badge> */}
                  {/* <div style={{ display: 'inline-block', marginLeft: 10 }}>

                  {order.fee?.size !== 0 && !order.fee_locked && (
                    <Tooltip title="待锁定">
                      <Tag
                        className={styles.convTag}
                        style={{
                          color: '#fff',
                          background: '#e84951',
                          borderColor: '#b40f0f',
                        }}
                      >
                        锁
                      </Tag>
                    </Tooltip>
                  )}
                  {timeout && (
                    <Tooltip title="超过两个小时未预约上门时间">
                      <Tag className={styles.convTag}>超</Tag>
                    </Tooltip>
                  )}
                  {order.prev_order && (
                    <Tooltip title="再次上门">
                      <Tag className={styles.convTag} color="orange">
                        再次
                      </Tag>
                    </Tooltip>
                  )}
                </div> */}
                </div>
                <div className={styles.descitem}>
                  产品名称：{order?.product_list?.length > 0 && order?.product_list[0] ? order?.product_list[0]?.name : ''}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div className={styles.worker}>
        <div className={styles.workercontent}>
          <div className={styles.workericon}>
            <Icon type="user" />
          </div>
          <span>{order.contact_name}{order?.is_retail ? '(散户)' : ''}</span>
          <span>{order.contact_mobile}</span>
          <span>{order.address}</span>
        </div>

        {(!Array.isArray(order.tip) || !order.tip.length) && <BottomRightMenu />}
      </div>
      {/** 这里是操作工单，通知工单，聊天记录显示位置 */}
      {(Array.isArray(order.tip) && order.tip.length > 0 && order?.tip?.[0]?.message_type != 2) && <div className={styles.worker}>
        <div className={styles.workercontent}>
          <span>{order.tip[0].role}</span>
          <span className={styles.color1}>{order.tip[0]?.user?.name}</span>
          {/* <span className={styles.color1}>{utils.tipType[order.tip[0].type]}</span> */}
          <span>{order.tip[0].message}</span>
          {(order?.tip?.[0]?.type == 3 || order?.tip?.[0]?.type == 12) && <span title={order.tip[0].value}>{order.tip[0].value}</span>}
          {order?.tip?.[0]?.message_type == 1 && <span>{order?.tenant_refuse_fee_reason}</span>}
        </div>
        <BottomRightMenu />
      </div>}
      {(Array.isArray(order.tip) && order.tip.length > 0 && order?.tip?.[0]?.message_type == 2) && <div className={styles.worker}>
        <div className={styles.workercontent}>
          {/* <span>{order.tip[0].role}</span>
          <span className={styles.color1}>{order.tip[0]?.user?.name}</span> */}
          {/* <span className={styles.color1}>{utils.tipType[order.tip[0].type]}</span> */}
          <span>{order.tip[0].message}</span>
        </div>
        <BottomRightMenu />
      </div>}
    </div>
  );
}

export default function TaskHall({
  className, taskList = [],
  taskHallSelectOrderId, change, showConvFold, tastHallType,
  resetTaskHall, onProcessedSuccess, onProcessedSuccessqqqq
}) {
  return (
    <div className={cn(className, styles.list)}>
      {taskList.map((item, index) => (
        <TaskItem key={index} convId={item.id} item={item} showConvFold={showConvFold}
          taskHallSelectOrderId={taskHallSelectOrderId} tastHallType={tastHallType} change={change}
          resetTaskHall={resetTaskHall} onProcessedSuccess={onProcessedSuccess} onProcessedSuccessqqqq={onProcessedSuccessqqqq} />
      ))}
    </div>
  );
}
